import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class SetAlreadyLoggedInOnceAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<AppState, any>,
    alreadyLoggedInOnce: boolean,
  ): void {
    commit(APP_CONSTS.mutations.setAlreadyLoggedInOnce, alreadyLoggedInOnce)
  }
}
